import React from 'react';

import { Input, Select, Tooltip, Button, InputNumber } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { graphql, withApollo } from 'react-apollo';

import _ from 'lodash';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

import getOrganismos from '../../../../graphql/querys/organismos/getOrganismos.graphql';

@graphql(getOrganismos)
class FormTalonario extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        this.props.onSubmit({
          codigo: values.codigo,
          nombre: values.nombre,
          cantidad: values.cantidad,
          idOrganismo: values.idOrganismo,
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  crearOpciones(organismo) {
    return (
      <Option key={organismo._id} value={organismo._id}>
        {organismo.nombre}
      </Option>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const listaOrganismos = this.props.data.getOrganismos;
    if (listaOrganismos) {
      var opcionesOrganismos = _.map(listaOrganismos, this.crearOpciones);
    }

    return (
      <div>
        <h1 className="tituloForm">Datos del Talonario</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Codigo
                <Tooltip title="El codigo que se mostrara del talonario ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('codigo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el codigo!',
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Nombre
                <Tooltip title="El nombre que se mostrara del  talonario ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('nombre', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el nombre!',
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Cantidad
                <Tooltip title="La cantidad actual del talonario ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('cantidad', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar la cantidad!',
                },
              ],
            })(<InputNumber min={0} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Organismo del talonario
                <Tooltip title="Seleccione el organismo al que le pertenece el talonario">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              rules: [
                { required: true, message: 'Por favor, ingrese el organismo!' },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500 }}
                placeholder="Seleccione un organismo"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opcionesOrganismos}
              </Select>
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Siguiente
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      codigo: Form.createFormField({
        value: props.datos ? props.datos.codigo : '',
      }),
      nombre: Form.createFormField({
        value: props.datos ? props.datos.nombre : '',
      }),
      cantidad: Form.createFormField({
        value: props.datos ? props.datos.cantidad : '',
      }),
      idOrganismo: Form.createFormField({
        value:
          props.datos && props.datos.organismo ? props.datos.organismo._id : '',
      }),
    };
  },
})(withApollo(FormTalonario));
